import { useCurrentRoute, useOfficeComponentContext, } from '@office-start/component-context-service';
import { useFeatureGates } from '@office-start/feature-gates-service';
import { useThemeMode } from '@office-start/theming-service';
import { useMemo } from 'react';
import { getVisualBackgroundImageURL } from '../util/getVisualBackgroundImageURL';
import { useVisualBackgroundEnabled } from './useVisualBackgroundEnabled';
import { useVisualBackgroundTelemetry } from './useVisualBackgroundTelemetry';
import { useVisualsThemeId } from './useVisualsThemeId';
export var useVisualBackgroundImage = function () {
    var componentContext = useOfficeComponentContext().data;
    var featureGates = useFeatureGates().data;
    var themeId = useVisualsThemeId();
    var themeMode = useThemeMode();
    var visualBackgroundEnabled = useVisualBackgroundEnabled();
    var currentRoute = useCurrentRoute();
    var telemetryCallbacks = useVisualBackgroundTelemetry({
        themeId: themeId,
        themeMode: themeMode,
    });
    var backgroundImageURL = useMemo(function () {
        var _a, _b, _c, _d;
        if (!componentContext || !featureGates || !themeMode || !themeId) {
            return undefined;
        }
        return getVisualBackgroundImageURL(themeId, themeMode, componentContext.cdnDomain, ((_b = (_a = featureGates.result) === null || _a === void 0 ? void 0 : _a.visualGates) === null || _b === void 0 ? void 0 : _b.visualBackgroundGradientEnabled) ||
            false, ((_d = (_c = featureGates.result) === null || _c === void 0 ? void 0 : _c.m365DefaultThemeGates) === null || _d === void 0 ? void 0 : _d.m365DefaultThemeEnabled) || false);
    }, [componentContext, featureGates, themeId, themeMode]);
    var backgroundGradient = useMemo(function () {
        var _a, _b;
        if (!featureGates || !themeMode) {
            return undefined;
        }
        return "".concat(themeMode).concat(((_b = (_a = featureGates.result) === null || _a === void 0 ? void 0 : _a.visualGates) === null || _b === void 0 ? void 0 : _b.visualBackgroundGradientEnabled)
            ? 'New'
            : '');
    }, [featureGates, themeMode]);
    return useMemo(function () {
        var _a, _b, _c, _d;
        if (!backgroundImageURL ||
            !backgroundGradient ||
            !currentRoute ||
            !featureGates ||
            !telemetryCallbacks ||
            !themeId ||
            !visualBackgroundEnabled) {
            return undefined;
        }
        return {
            backgroundImageURL: backgroundImageURL,
            backgroundGradient: backgroundGradient,
            isHomePage: currentRoute.route === 'OfficeHome' ||
                currentRoute.route === 'Pwa',
            isOpacity32: ((_b = (_a = featureGates.result) === null || _a === void 0 ? void 0 : _a.m365DefaultThemeGates) === null || _b === void 0 ? void 0 : _b.m365DefaultThemeEnabled) || false,
            themeId: themeId,
            telemetryCallbacks: telemetryCallbacks,
            visualBackgroundGradientEnabled: ((_d = (_c = featureGates.result) === null || _c === void 0 ? void 0 : _c.visualGates) === null || _d === void 0 ? void 0 : _d.visualBackgroundGradientEnabled) || false,
        };
    }, [
        backgroundImageURL,
        backgroundGradient,
        currentRoute,
        featureGates,
        telemetryCallbacks,
        themeId,
        visualBackgroundEnabled,
    ]);
};
//# sourceMappingURL=useVisualBackgroundImage.js.map